import { SearchInput } from "@/components/atoms";
import { usePagination } from "@/hooks";
import { useGetUninvoicedJobsCompaniesParams } from "../hooks";

export const UninvoicedJobsCompaniesSearch = () => {
  const { search, setSearch } = useGetUninvoicedJobsCompaniesParams();
  const { clearPagination } = usePagination("uninvoicedJobs");

  const handleSearch = (value?: string) => {
    clearPagination();
    setSearch(value);
  };

  return <SearchInput search={search} onSearch={handleSearch} placeholder="Search..." size="md" />;
};
